import React from 'react'
import { getThemeName } from '../utils'

const SpritzFont = React.lazy(() => import('./Spritz'))
const QuickswapFont = React.lazy(() => import('./Quickswap'))

export const FontSelector = () => {
    const theme = getThemeName()
    return (
        <React.Suspense fallback={null}>
            {theme === 'quickswap' ? <QuickswapFont /> : <SpritzFont />}
        </React.Suspense>
    )
}
